var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:{'disabled': _vm.disabled, 'icon-only': !_vm.action},attrs:{"disabled":_vm.disabled}},[_vm._t("default"),(_vm.action)?_c('span',[_vm._v(_vm._s(_vm.action))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }